import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import { useNavigate } from 'react-router-dom';
import { Scale, FileText } from 'lucide-react';
import { ScoringTab, PromptTab } from './aiFeatureTabs';

const FEATURE_KEY = 'elevator_pitch';
const SCORING_BASE = '/pitch/admin/scoring/categories';

const TABS = [
    { key: 'scoring', label: 'Scoring', Icon: Scale },
    { key: 'prompt', label: 'AI Prompt', Icon: FileText },
];

export default function PitchManagement() {
    const { user } = useAuth();
    const { isDarkMode } = useTheme();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('scoring');

    useEffect(() => {
        if (!user || !user.isAdmin) {
            navigate('/userdashboard');
        }
    }, [user, navigate]);

    return (
        <div className={`min-h-screen ${isDarkMode ? 'bg-slate-900' : 'bg-surface'}`}>
            <div className="max-w-7xl mx-auto px-4 py-8">
                <header className="mb-8">
                    <h1 className={`text-3xl font-extrabold tracking-tight mb-2 ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>Pitch Management</h1>
                    <p className={isDarkMode ? 'text-slate-400' : 'text-slate-600'}>Configure elevator-pitch scoring and the AI analysis prompt. Per-tier usage limits are set on the Membership Tiers page.</p>
                </header>

                <div className={`mb-6 border-b ${isDarkMode ? 'border-slate-700' : 'border-slate-200'}`}>
                    <div className="flex gap-4">
                        {TABS.map(({ key, label, Icon }) => (
                            <button
                                key={key}
                                onClick={() => setActiveTab(key)}
                                className={`px-4 py-2 font-semibold border-b-2 transition-colors ${
                                    activeTab === key
                                        ? 'border-blue-600 text-blue-600'
                                        : isDarkMode
                                            ? 'border-transparent text-slate-400 hover:text-slate-200'
                                            : 'border-transparent text-slate-600 hover:text-slate-900'
                                }`}
                            >
                                <Icon size={18} className="inline mr-2" />
                                {label}
                            </button>
                        ))}
                    </div>
                </div>

                {activeTab === 'scoring' && (
                    <ScoringTab
                        isDarkMode={isDarkMode}
                        scoringBase={SCORING_BASE}
                        blurb="Configure the categories, weights, and grading rubrics used for AI-powered elevator pitch scoring"
                    />
                )}
                {activeTab === 'prompt' && <PromptTab isDarkMode={isDarkMode} featureKey={FEATURE_KEY} />}
            </div>
        </div>
    );
}
